!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.draftjsToMarkdown = e() : t.draftjsToMarkdown = e();
}(window, function () {
  return r = {}, o.m = n = [function (t, e, n) {
    t.exports = n(1);
  }, function (t, e, n) {
    "use strict";

    function i(t, e) {
      if (t) for (var n in t) {
        !{}.hasOwnProperty.call(t, n) || e(n, t[n]);
      }
    }

    function f(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function s(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    n.r(e), n.d(e, "sameStyleAsPrevious", function () {
      return d;
    }), n.d(e, "getStylesAtOffset", function () {
      return p;
    }), n.d(e, "addInlineStyleMarkdown", function () {
      return g;
    }), n.d(e, "addStylePropertyMarkdown", function () {
      return T;
    }), n.d(e, "trimLeadingZeros", function () {
      return b;
    }), n.d(e, "trimTrailingZeros", function () {
      return R;
    }), n.d(e, "getBlockContentMarkdown", function () {
      return E;
    }), n.d(e, "getBlockStyle", function () {
      return S;
    }), n.d(e, "default", function () {
      return r;
    });
    var l = {
      unstyled: "",
      "header-one": "# ",
      "header-two": "## ",
      "header-three": "### ",
      "header-four": "#### ",
      "header-five": "##### ",
      "header-six": "###### ",
      "unordered-list-item": "- ",
      "ordered-list-item": "1. ",
      blockquote: "> ",
      code: "    "
    };

    function O(t, e, n, r) {
      var o = t[e];

      if ("function" == typeof r) {
        var c = r(o, n);
        if (c) return c;
      }

      return "MENTION" === o.type ? "[".concat(n, "](").concat(o.data.url, ")") : "LINK" === o.type ? "[".concat(n, "](").concat(o.data.url, ")") : "IMAGE" === o.type ? "![".concat(o.data.alt || "", "](").concat(o.data.src, ")") : "EMBEDDED_LINK" === o.type ? '<iframe width="'.concat(o.data.width, '" height="').concat(o.data.height, '" src="').concat(o.data.src, '" frameBorder="0" allowFullScreen />') : n;
    }

    function y(t, e) {
      var n = [],
          r = 0,
          o = t.entityRanges.map(function (t) {
        return {
          offset: t.offset,
          length: t.length,
          key: t.key,
          type: "ENTITY"
        };
      });
      return (o = (o = o.concat(function (t, e) {
        var n = [];
        if (e) for (var r = 0, o = 0, c = t, a = e.trigger || "#", u = e.separator || " "; 0 < c.length && 0 <= o;) {
          if (c[0] === a ? (r = o = 0, c = c.substr(a.length)) : 0 <= (o = c.indexOf(u + a)) && (c = c.substr(o + (u + a).length), r += o + u.length), 0 <= o) {
            var i = 0 <= c.indexOf(u) ? c.indexOf(u) : c.length,
                f = c.substr(0, i);
            f && 0 < f.length && n.push({
              offset: r,
              length: f.length + a.length,
              type: "HASHTAG"
            }), r += a.length;
          }
        }
        return n;
      }(t.text, e))).sort(function (t, e) {
        return t.offset - e.offset;
      })).forEach(function (t) {
        t.offset > r && n.push({
          start: r,
          end: t.offset - 1
        }), n.push({
          start: t.offset,
          end: t.offset + t.length,
          entityKey: t.key,
          type: t.type
        }), r = t.offset + t.length;
      }), r < t.text.length && n.push({
        start: r,
        end: t.text.length
      }), n;
    }

    function d(e, t, n) {
      var r = !0;
      return 0 < n && n < e.length ? t.forEach(function (t) {
        r = r && e[t][n] === e[t][n - 1];
      }) : r = !1, r;
    }

    function p(t, e) {
      var n = {};
      return t.COLOR[e] && (n.COLOR = t.COLOR[e]), t.BGCOLOR[e] && (n.BGCOLOR = t.BGCOLOR[e]), t.FONTSIZE[e] && (n.FONTSIZE = t.FONTSIZE[e]), t.FONTFAMILY[e] && (n.FONTFAMILY = t.FONTFAMILY[e]), t.SUBSCRIPT[e] && (n.SUBSCRIPT = !0), t.SUPERSCRIPT[e] && (n.SUPERSCRIPT = !0), t.CODE[e] && (n.CODE = !0), t.STRIKETHROUGH[e] && (n.STRIKETHROUGH = !0), t.UNDERLINE[e] && (n.UNDERLINE = !0), t.ITALIC[e] && (n.ITALIC = !0), t.BOLD[e] && (n.BOLD = !0), n;
    }

    function h(t, e, n, r) {
      var o,
          c,
          a,
          u,
          i = [],
          f = t.text;
      if (0 < f.length) for (var s, l = (c = (o = t).text, a = o.inlineStyleRanges, u = {
        COLOR: new Array(c.length),
        BGCOLOR: new Array(c.length),
        FONTSIZE: new Array(c.length),
        FONTFAMILY: new Array(c.length),
        SUBSCRIPT: new Array(c.length),
        SUPERSCRIPT: new Array(c.length),
        CODE: new Array(c.length),
        STRIKETHROUGH: new Array(c.length),
        UNDERLINE: new Array(c.length),
        ITALIC: new Array(c.length),
        BOLD: new Array(c.length),
        length: c.length
      }, a && 0 < a.length && a.forEach(function (t) {
        for (var e = t.offset, n = e + t.length, r = e; r < n; r += 1) {
          0 === t.style.indexOf("color-") ? u.COLOR[r] = t.style.substring(6) : 0 === t.style.indexOf("bgcolor-") ? u.BGCOLOR[r] = t.style.substring(8) : 0 === t.style.indexOf("fontsize-") ? u.FONTSIZE[r] = t.style.substring(9) : 0 === t.style.indexOf("fontfamily-") ? u.FONTFAMILY[r] = t.style.substring(11) : u[t.style] && (u[t.style][r] = !0);
        }
      }), u), O = n; O < r; O += 1) {
        O !== n && d(l, e, O) ? (s.text.push(f[O]), s.end = O + 1) : (s = {
          styles: p(l, O),
          text: [f[O]],
          start: O,
          end: O + 1
        }, i.push(s));
      }
      return i;
    }

    function g(t, e) {
      return "BOLD" === t ? "**".concat(e, "**") : "ITALIC" === t ? "*".concat(e, "*") : "UNDERLINE" === t ? "__".concat(e, "__") : "STRIKETHROUGH" === t ? "~~".concat(e, "~~") : "CODE" === t ? "`".concat(e, "`") : "SUPERSCRIPT" === t ? "<sup>".concat(e, "</sup>") : "SUBSCRIPT" === t ? "<sub>".concat(e, "</sub>") : e;
    }

    function T(t) {
      var e,
          n = t.styles,
          r = t.text,
          o = (e = r) && 0 < e.length ? e.map(function (t) {
        switch (t) {
          case "\n":
            return "\\s\\s\n";

          case "&":
            return "&amp;";

          case "<":
            return "&lt;";

          case ">":
            return "&gt;";

          default:
            return t;
        }
      }).join("") : "";

      if (n && (n.COLOR || n.BGCOLOR || n.FONTSIZE || n.FONTFAMILY)) {
        var c = 'style="';
        return n.COLOR && (c += "color: ".concat(n.COLOR, ";")), n.BGCOLOR && (c += "background-color: ".concat(n.BGCOLOR, ";")), n.FONTSIZE && (c += "font-size: ".concat(n.FONTSIZE, "px;")), n.FONTFAMILY && (c += "font-family: ".concat(n.FONTFAMILY, ";")), "<span ".concat(c += '"', ">").concat(o, "</span>");
      }

      return o;
    }

    function I(c, t, e, n) {
      var r = [],
          o = h(c, ["BOLD", "ITALIC", "UNDERLINE", "STRIKETHROUGH", "CODE", "SUPERSCRIPT", "SUBSCRIPT"], e.start, e.end),
          a = "";
      o.forEach(function (t) {
        var e,
            n,
            r = h(c, ["COLOR", "BGCOLOR", "FONTSIZE", "FONTFAMILY"], t.start, t.end),
            o = "";
        r.forEach(function (t) {
          o += T(t);
        }), a += (e = t.styles, n = o, i(e, function (t, e) {
          n = g(t, n);
        }), n);
      }), r.push(a);
      var u = r.join("");
      return "ENTITY" === e.type ? void 0 !== e.entityKey && null !== e.entityKey && (u = O(t, e.entityKey, u, n)) : "HASHTAG" === e.type && (u = "[".concat(u, "](").concat(u, ")")), u;
    }

    function b(t) {
      if (t) {
        for (var e = t, n = 0; n < e.length && " " === t[n]; n += 1) {
          e = e.replace(" ", "&nbsp;");
        }

        return e;
      }

      return t;
    }

    function R(t) {
      if (t) {
        for (var e = t, n = e.length - 1; 0 <= n && " " === e[n]; --n) {
          e = "".concat(e.substring(0, n), "&nbsp;").concat(e.substring(n + 1));
        }

        return e;
      }

      return t;
    }

    function E(r, o, t, c) {
      if (0 < (e = r).entityRanges.length && (null == (n = e.text) || 0 === n.length || 0 === n.trim().length)) return O(o, r.entityRanges[0].key, void 0, c);
      var e,
          n,
          a = [],
          u = y(r, t);
      return u.forEach(function (t, e) {
        var n = I(r, o, t, c);
        0 === e && (n = b(n)), e === u.length - 1 && (n = R(n)), a.push(n);
      }), a.join("");
    }

    function S(t) {
      var n = "";
      return i(t, function (t, e) {
        n += "".concat(t, ":").concat(e, ";");
      }), n;
    }

    function v(t, e, n, r, o, c) {
      var a = [];
      a.push(e[t.type]);
      var u,
          i,
          f,
          s = E(t, n, r, o);
      return t.data && (u = t.data, i = s, s = (f = S(u)) ? '<span style="'.concat(f, '">').concat(i, "</span>") : i), a.push(s), a.push(c && c.emptyLineBeforeBlock ? "\n\n" : "\n"), a.join("");
    }

    function r(t, r, o, c) {
      var a = [];

      if (t) {
        var u = function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? f(Object(n), !0).forEach(function (t) {
              s(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }

          return e;
        }({}, l, {}, c && c.blockTypesMapping && c.blockTypesMapping),
            e = t.blocks,
            i = t.entityMap;

        e && 0 < e.length && e.forEach(function (t) {
          var e,
              n = v(t, u, i, r, o, c);
          "unordered-list-item" !== (e = t.type) && "ordered-list-item" !== e || (n = function (t) {
            for (var e = "", n = 0; n < 4 * t; n += 1) {
              e += " ";
            }

            return e;
          }(t.depth) + n), a.push(n);
        });
      }

      return a.join("");
    }
  }], o.c = r, o.d = function (t, e, n) {
    o.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: n
    });
  }, o.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, o.t = function (e, t) {
    if (1 & t && (e = o(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (o.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var r in e) {
      o.d(n, r, function (t) {
        return e[t];
      }.bind(null, r));
    }
    return n;
  }, o.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return o.d(e, "a", e), e;
  }, o.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, o.p = "", o(o.s = 0);

  function o(t) {
    if (r[t]) return r[t].exports;
    var e = r[t] = {
      i: t,
      l: !1,
      exports: {}
    };
    return n[t].call(e.exports, e, e.exports, o), e.l = !0, e.exports;
  }

  var n, r;
});